module.exports = __webpack_public_path__ + "img/contact.fdebce08.png";